import { UniButton } from '@/design-system/components/buttons';
import { Icon } from '@/design-system/components/icons/Icon';
import { TextBody, TextTitle } from '@/design-system/components/typography';
import { SxProp, View, Image, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Row } from '@/design-system/components/layout';
import { LinearGradient } from 'expo-linear-gradient';

export interface ReplaceCardProps {
  onClose: () => void;
}

export const ReplaceCardNativeThreeScreen: React.FC<ReplaceCardProps> = (props) => {
  const { onClose } = props;
  const { t } = useTranslation('account-management');
  const { topHeader, body, textMb, itemStyle, address, textColor, itemAlign, modal, btn } = sxStyles;
  const [selected, setSelected] = useState<boolean>(false);

  const { theme } = useDripsyTheme();
  const Gradient = styled(LinearGradient, {})({});

  return (
    <View>
      <Gradient colors={['rgba(49, 75, 108, 0.8)', 'rgba(39, 70, 115, 0.8)', '#3C6291', '#1E304B']}>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              Replace Card
            </TextTitle>
          </View>
        </Row>
      </Gradient>
      <View sx={modal}>
        <View sx={topHeader}>
          <Icon name="successSpecial" height={80} width={80} />
          <View sx={textMb}>
            <TextTitle bold>Replace Card Instruction Placed</TextTitle>
            <TextBody>Your new UTGL Card will be sent to your mailing address in 4-5 business days when ready.</TextBody>
          </View>
        </View>
        <View sx={body}>
          <View sx={{ gap: 12 }}>
            <TextBody sx={itemStyle}>
              <TextBody secondary>Reason to replace card</TextBody>
              <TextBody>It’s lost/stolen</TextBody>
            </TextBody>
            <TextBody sx={itemAlign}>
              <TextBody secondary>Delivery Method</TextBody>
              <TextBody sx={address}>
                Mail to address: <br /> Block 1, 1/F, Flat A, Super
                <br /> Building, 1 Sample Road, <br />
                Jordan, Hong Kong
              </TextBody>
            </TextBody>
            <TextBody sx={itemStyle}>
              <TextBody secondary>Replacement Fee</TextBody>
              <TextBody sx={textColor}>- 50.00 HKD</TextBody>
            </TextBody>
            <TextBody sx={itemStyle}>
              <TextBody secondary>Instruction Time</TextBody>
              <TextBody>2022-09-01 16:44:00</TextBody>
            </TextBody>
            <TextBody sx={itemStyle}>
              <TextBody secondary>Ref ID</TextBody>
              <TextBody>A123456789</TextBody>
            </TextBody>
          </View>
          <View sx={btn}>
            <UniButton sx={{ width: '100%' }} label="Reture" onPress={onClose} />
          </View>
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    padding: '$5'
  },
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '$10'
  },
  body: {},
  textMb: {
    textAlign: 'center',
    gap: 8
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 20
  },
  itemAlign: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  title: {
    color: '$textSecondary',
    fontSize: 12
  },
  address: {
    textAlign: 'right',
    lineHeight: 20
  },
  textColor: {
    color: '#F5423E'
  },
  btn: {
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 30
  }
};
